import { CourseOfStudyDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CourseOfStudyService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCourseOfStudy(): Observable<CourseOfStudyDto[]> {
    return this.http.get<CourseOfStudyDto[]>(this.url + 'courseofstudy');
  }

  createCourseOfStudy(
    data: CourseOfStudyDto[]
  ): Observable<CourseOfStudyDto[]> {
    return this.http.post<CourseOfStudyDto[]>(this.url + 'courseofstudy', data);
  }
  getSingleCourseOfStudy(id: string): Observable<any> {
    return this.http.get(this.url + 'courseofstudy/' + id);
  }

  updateCourseOfStudy(
    data: CourseOfStudyDto[]
  ): Observable<CourseOfStudyDto[]> {
    return this.http.post<CourseOfStudyDto[]>(
      this.url + 'courseofstudy/update',
      data
    );
  }

  deleteCourseOfStudy(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('courseofstudy', ids.join(', '));
    return this.http.delete(this.url + 'courseofstudy', httpOptions);
  }
}
